import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import PhoneContactButton from './components/phone-contact-button';
import EmailContactButton from './components/email-contact-button';
import ScheduleButton from './components/schedule-button';
import './index.css';

function ContactActions ({id, name, type, deletable, editable, shareable, phoneNumber, email, fromAutocomplete, history}) {

	const { t } = useTranslation();

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);

	return (
		<div className="contact-actions">
			{
				editable
				&& phoneNumber
				&& selectedContactsGroup && selectedContactsGroup.directorySyncStatus !== 'RUNNING'
					?
					<PhoneContactButton title={t("phoneContact")} contactPhone={phoneNumber} />
					:
					<PhoneContactButton disabled={true} title={t("phoneContact")} contactPhone={phoneNumber}/>
			}
			{
				editable
				&& email
				&& selectedContactsGroup && selectedContactsGroup.directorySyncStatus !== 'RUNNING'
					?
					<EmailContactButton title={t("emailContact")} contactEmail={email} />
					:
					<EmailContactButton disabled={true} title={t("emailContact")} contactEmail={email}/>
			}
			{
				editable
				&& email
				&& selectedContactsGroup && selectedContactsGroup.directorySyncStatus !== 'RUNNING'
					?
					<ScheduleButton title={t("scheduleBtn")} email={email}/>
					:
					<ScheduleButton title={t("scheduleBtn")} email={email} disabled={true}/>
			}
		</div>
	)
}

export default ContactActions;
